import { Component, Input, SimpleChanges, ViewChild, OnChanges, AfterViewInit, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Error429Service } from 'src/app/services/error429.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-perfil',
  templateUrl: './perfil.component.html',
  styleUrls: ['./perfil.component.css']
})
export class PerfilComponent implements OnChanges, OnInit{

  @ViewChild('emailInput') emailInput: any;
  @ViewChild('nameInput') nameInput: any;
  @ViewChild('createdInput') createdInput: any;
  @ViewChild('updatedInput') updatedInput: any;
  @ViewChild('tipoInput') tipoInput: any;
  @ViewChild('clientInput') clientInput: any;
  @ViewChild('statusInput') statusInput: any;
  emailInputWidth: number = 100;
  nameInputWidth: number = 100;
  createdInputWidth: number = 100;
  updatedInputWidth: number = 100;
  tipoInputWidth: number = 100;
  clientInputWidth: number = 100;
  maxInputWidth: number = 300;
  statusInputWidth: number = 100;

  clients: any[] = []; //Información básica los clientes
  tipoUsuario: string = "";
  errorMessage: string = "";
  tiempoEsperaRecarga: number = 60000;
  userClient: string = "";
  userStatus: string = "";

  private clientsSubscription: Subscription | undefined;

  @Input() userData: any;

  constructor(private userService: UserService, private router: Router, private cdRef: ChangeDetectorRef,
    private error429: Error429Service){}

  ngOnInit(): void {
    this.clientsSubscription = this.userService.getClients().subscribe({
      next:resp =>{
        for(let i=0; i<resp.length; i++){
          this.clients.push(resp[i]);
        }
        for (let i=0; i<this.clients.length; i++){
          if(this.clients[i].id == this.userData.cliente_id){
            this.userClient = this.clients[i].razon_social;
          }
        }
        console.log(this.userClient);
      },error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete:()=>{
        console.log(this.clients);
        this.calculateInputWidth(this.userClient, this.clientInput, 'Client');
        //Es necesario poner esta función dos veces para que se calculen bien los valores
        this.calculateMaxInputWidth();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['userData'] && this.userData !== undefined && this.userData.length !== 0) {
      console.log(this.userData);
      this.calculateInputWidth(this.userData.user_fullname, this.nameInput, 'Name');
      this.calculateInputWidth(this.userData.user_mail, this.emailInput, 'Email');
      this.calculateInputWidth(this.formatDateTime(this.userData.created_at), this.createdInputWidth, 'Created');
      this.calculateInputWidth(this.formatDateTime(this.userData.updated_at), this.updatedInputWidth, 'Updated');

      //Tipo de Usuario
      if(this.userData.pro_id == 4){
        this.tipoUsuario = "Super usuario root"
      }
      if(this.userData.pro_id == 1){
        this.tipoUsuario = "Administrador"
      }
      if(this.userData.pro_id == 2){
        this.tipoUsuario = "Hostelero"
      }
      if(this.userData.pro_id == 3){
        this.tipoUsuario = "Consumidor"
      }
      this.calculateInputWidth(this.tipoUsuario, this.tipoInput, 'Type');

      //Estado
      if(this.userData.user_status == 1){
        this.userStatus = "Activado"
      }
      if(this.userData.user_status == 0){
        this.userStatus = "Desactivado"
      }
      this.calculateInputWidth(this.userStatus, this.statusInput, 'Status');

      //Ver cual es el tamaño más grande
      this.calculateMaxInputWidth();
    }
  }

  ngOnDestroy(): void {
    if (this.clientsSubscription) {
      this.clientsSubscription.unsubscribe();
    } 
  }

  calculateMaxInputWidth() {
    this.maxInputWidth = Math.max(
      this.emailInputWidth,
      this.nameInputWidth,
      this.createdInputWidth,
      this.updatedInputWidth,
      this.tipoInputWidth,
      this.clientInputWidth
    );
    /*console.log(  
      this.emailInputWidth,
      this.nameInputWidth,
      this.createdInputWidth,
      this.updatedInputWidth,
      this.tipoInputWidth,
      this.clientInputWidth);*/

    //console.log('Ancho máximo:', this.maxInputWidth);
  }

  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  calculateInputWidth(value: string, dom: any, input: 'Email' | 'Name' | 'Created' | 'Updated' | 'Type' | 'Client'| 'Status') {
    if (dom) {
      const textWidth = this.calculateTextWidth(value, "22px Roboto");
      if (input === 'Email') {
        this.emailInputWidth = textWidth + 20;
      } else if (input === 'Name') {
        this.nameInputWidth = textWidth + 22;
      } else if (input === 'Created') {
        this.createdInputWidth = textWidth + 20;
      } else if (input === 'Type') {
        this.tipoInputWidth = textWidth + 20;
      } else if (input === 'Updated') {
        this.updatedInputWidth = textWidth + 20;
      } else if (input === 'Client') {
        this.clientInputWidth = textWidth + 20;
      } 
    }
  }

  //Función para caulcular el ancho de un string
  calculateTextWidth(text: string, font: string): number {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (context) {
      context.font = font;
      const metrics = context.measureText(text);
      return metrics.width;
    }
    return 0;
  }

  //Función para convertir la fecha
  formatDateTime(dateTimeString: string | null): string {
    if (dateTimeString !== null) {
      const inputDate = new Date(dateTimeString);
      const year = inputDate.getFullYear();
      const month = ('0' + (inputDate.getMonth() + 1)).slice(-2);
      const day = ('0' + inputDate.getDate()).slice(-2);
      const hours = ('0' + inputDate.getHours()).slice(-2);
      const minutes = ('0' + inputDate.getMinutes()).slice(-2);
      const seconds = ('0' + inputDate.getSeconds()).slice(-2);
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
    return '';
  }
}
